"use client"

import React from "react"

import NeloButton from "@modules/common/components/nelo-button"

import { SignupFlowType } from "../index"

const VerificationOptions = (props: {
  onShouldVerifyInWeb: () => void
  onShouldVerifyInApp: () => void
  onShouldVerifyInWhatsapp: () => void
  verificationPath: SignupFlowType | null
  isWhatsappLinkLoading?: boolean
  whatsappError?: string | null
}) => {
  const renderVerificationCta = () => {
    if (props.verificationPath === "web") {
      return (
        <NeloButton onClick={props.onShouldVerifyInApp} className="w-full">
          Continuar en la app
        </NeloButton>
      )
    } else if (props.verificationPath === "web_wa_idv") {
      return (
        <NeloButton onClick={() => props.onShouldVerifyInWhatsapp()} className="w-full" loading={props.isWhatsappLinkLoading}>
          Verificar vía WhatsApp
        </NeloButton>
      )
    } else if (props.verificationPath === "webv") {
      return (
        <NeloButton onClick={props.onShouldVerifyInWeb} className="w-full">
          Iniciar verificación
        </NeloButton>
      )
    } else {
      return (
        <NeloButton onClick={props.onShouldVerifyInApp} className="w-full">
          Continuar en la app
        </NeloButton>
      )
    }
  }

  const verificationScreenTitle = () => {
    if (props.verificationPath === "web") {
      return <h1 className="mb-4 text-4xl font-bold text-nelo-blue">Para terminar, por favor descarga la app y verifica tu identidad</h1>
    } else if (props.verificationPath === "web_wa_idv") {
      return <h1 className="mb-4 text-4xl font-bold text-nelo-blue">Para terminar, verifica tu identidad vía WhatsApp</h1>
    } else if (props.verificationPath === "webv") {
      return <h1 className="mb-4 text-4xl font-bold text-nelo-blue">Para terminar, por favor verifica tu identidad</h1>
    } else {
      return <h1 className="mb-4 text-4xl font-bold text-nelo-blue">Para terminar, por favor descarga la app y verifica tu identidad</h1>
    }
  }

  const verificationScreenDescription = () => {
    if (props.verificationPath === "web" || props.verificationPath === "webv") {
      return (
        <p className="text-ui-fg-base">Verifica tu identidad para completar tu compra. Tus datos son confidenciales en todo momento.</p>
      )
    } else if (props.verificationPath === "web_wa_idv") {
      return (
        <p className="text-ui-fg-base">
          Haz clic en el botón a continuación para comenzar la{" "}
          <span className="font-bold text-nelo-blue">verificación de identidad vía WhatsApp</span>{" "}
        </p>
      )
    } else {
      return (
        <p className="text-ui-fg-base">Verifica tu identidad para completar tu compra. Tus datos son confidenciales en todo momento.</p>
      )
    }
  }

  const verificationScreenWhatsappError = () => {
    if (props.whatsappError) {
      return <p className="rounded-lg bg-red-50 p-4 text-red-500">Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.</p>
    }
  }

  return (
    <div className="flex h-screen w-full flex-col overflow-y-auto px-8 pb-8 pt-24">
      {verificationScreenTitle()}
      <p className="text-ui-fg-base">
        Por seguridad, necesitamos confirmar que eres tú quien solicita el crédito Nelo.<br></br>
        <br></br>
        {verificationScreenDescription()}
      </p>
      <div className="mb-1 mt-4 flex flex-col gap-2 rounded-lg bg-nelo-sky-200 p-4">
        <span className="text-ui-fg-base">Para verificar tu identidad necesitas:</span>
        <li className="flex items-center">
          <div className="mr-2 h-2 w-2 shrink-0 rounded-full bg-nelo-blue"></div>
          <span className="text-ui-fg-base">Tu credencial INE vigente</span>
        </li>
        <li className="flex items-center">
          <div className="mr-2 h-2 w-2 shrink-0 rounded-full bg-nelo-blue"></div>
          <span className="text-ui-fg-base">Grabar un video de tu cara</span>
        </li>
      </div>
      {verificationScreenWhatsappError()}
      <div className="w-full md:w-1/2">
        <div className="mt-4">{renderVerificationCta()}</div>
      </div>
    </div>
  )
}

export default VerificationOptions
